/* eslint-disable camelcase */
import {ubcSendH5 as send} from '@baidu/med-utils/lib/ubcV2/ubc.h5';
import {EVENT_NAME, EVENT_TYPE_CLK, EVENT_TYPE_VIEW} from '@/dicts/ubcConfig';
import {customizeLogType} from '@/interfaces/specialDisease';
import {getUrlParamValue} from './utils';

export const logClkReport = (
    page: string,
    value: string,
    channelId?: string,
    page_type?: string,
    valueId?: number,
    valueTitle?: string,
    // 自定义扩展字段
    customize?: customizeLogType
) => {
    const defaultMsg = {
        page_source_key: 'id',
        page_source_id: channelId,
        page_type: page_type ?? '',
        value_id: valueId,
        value_title: valueTitle ?? '',
        in_ref_from: getUrlParamValue(window.location.href, 'from'),
        sf_ref: getUrlParamValue(window.location.href, 'sf_ref'),
        sf_ch: getUrlParamValue(window.location.href, 'sf_ch'),
        referrer: window && window.document && window.document.referrer,
    };
    const logClkMsg = Object.assign(defaultMsg, customize || {});
    send({
        type: EVENT_TYPE_CLK,
        value: value,
        page: page,
        ext: logClkMsg,
    }, EVENT_NAME);
};


export const logVewReport = (
    page: string,
    value: string,
    sfRef?: string,
    channelId?: string,
    page_type?: string,
    moduleId?: number,
    moduleName?: string
) => {
    send({
        type: EVENT_TYPE_VIEW,
        value: value,
        page: page,
        ext: {
            page_source_key: 'id',
            sf_ref: sfRef,
            page_source_id: channelId,
            page_type: page_type ?? '',
            value_id: moduleId,
            value_title: moduleName,
        },
    }, EVENT_NAME);
};

interface UbcSendOptionsH5 {
    type?: 'view' | 'clk' | 'play';
    value: string;
    page: string;
    ext?: Record<string, any>;
}

export const view = (options: UbcSendOptionsH5) => {
    send(Object.assign({
        type: 'view',
        from: 'content-external-channel',
        ext: {
            pd: 'toolbox',
        },
    }, options), EVENT_NAME);
};

export const clk = (options: UbcSendOptionsH5) => {
    send(Object.assign({
        type: 'clk',
        from: 'content-external-channel',
        ext: Object.assign({}, {
            pd: 'toolbox',
        }, options.ext),
    }, options), EVENT_NAME);
};

export const play = (options: UbcSendOptionsH5) => {
    send(Object.assign({
        type: 'clk',
        from: 'content-external-channel',
        pageSourceKey: 'id',
        ext: options.ext,
    }, options), EVENT_NAME);
};
